import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { HandleError } from '../../utils/handler-error';
import {
  CashShift,
  CashShiftCloseSummary,
  CashShiftCurrentResponse
} from './cash-shift';
import { ResponseData } from '../../utils/response';

@Injectable({ providedIn: 'root' })
export class CashShiftService {
  private readonly baseUrl = `${environment.API}/cash-shift`;

  constructor(private http: HttpClient) {}

  public getCurrent(): Observable<ResponseData<CashShiftCurrentResponse>> {
    return this.http.get<ResponseData<CashShiftCurrentResponse>>(`${this.baseUrl}/current`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public getCloseSummary(): Observable<ResponseData<CashShiftCloseSummary>> {
    return this.http.get<ResponseData<CashShiftCloseSummary>>(`${this.baseUrl}/summary`)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public openShift(openingFloat: number): Observable<ResponseData<CashShift>> {
    return this.http.post<ResponseData<CashShift>>(`${this.baseUrl}/open`, { openingFloat })
      .pipe(catchError(HandleError.handlerErrorObservable));
  }

  public closeShift(payload: {
    countedCash: number;
    notes?: string;
    confirmUnpaidOrders?: boolean;
  }): Observable<ResponseData<CashShift>> {
    return this.http.post<ResponseData<CashShift>>(`${this.baseUrl}/close`, payload)
      .pipe(catchError(HandleError.handlerErrorObservable));
  }
}
